module.exports = __webpack_public_path__ + "img/commerciale_idle.c86d8b48.png";